var _path, _path2, _ellipse, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPreciseLocationSsSelectedFocused({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 56,
    viewBox: "0 0 30 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M29.5092 41C29.5092 49.008 23.0154 55.5 15.0046 55.5C6.99379 55.5 0.5 49.008 0.5 41C0.5 32.992 6.99379 26.5 15.0046 26.5C23.0154 26.5 29.5092 32.992 29.5092 41Z",
    fill: "#EE4360",
    fillOpacity: 0.3,
    stroke: "#FFA4B5"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M29.0086 14.7143C29.0086 20.2 19.6724 34.5238 15.0043 41C10.4659 34.3968 0.999783 20.4286 1 14.7143C1.00025 8.2269 6.05711 1 15.0043 1C23.9515 1 29.0086 7.85714 29.0086 14.7143Z",
    fill: "#EE4360",
    stroke: "#EE4360",
    strokeWidth: 2
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 15.1631,
    cy: 14.7081,
    rx: 12.4483,
    ry: 12.1905,
    fill: "#EE4360"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23 14C23 14.0481 22.9996 14.0962 22.9987 14.1441V13.8559C22.9996 13.9038 23 13.9519 23 14ZM15 22C17.2088 22 19.2086 21.1048 20.6562 19.6575L17.8278 16.8291C17.104 17.5525 16.1042 18 15 18C12.7909 18 11 16.2091 11 14C11 11.7909 12.7909 10 15 10C16.1042 10 17.104 10.4475 17.8278 11.1709L20.6562 8.34251C19.2086 6.89517 17.2088 6 15 6C10.5817 6 7 9.58172 7 14C7 18.4183 10.5817 22 15 22Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPreciseLocationSsSelectedFocused);
export default __webpack_public_path__ + "static/media/precise-location-ss-selected-focused.18a09901b61dea38e9351c14a8e5933b.svg";
export { ForwardRef as ReactComponent };